import "./Navbar.css"
import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { useTranslation } from "react-i18next";


import homeicon from '../../../img/home.svg';
import productsicon from '../../../img/products.svg';
import searchicon from '../../../img/search.svg';
import menu from '../../../img/menu.svg';
import dpp from  '../../../img/dpp_logo.svg';
import homepageIconSelected from '../../../img/home-selected.svg';
import productsIconSelected from '../../../img/products-selected.svg';
import searchiconSelected from '../../../img/search-selected.svg';



const Navbar = ({ MenuClick, isHomepage }) => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  // Obtém a rota atual
  const location = useLocation();
  const { t } = useTranslation();
  // Verifica a rota atual
  const isProductsRoute = location.pathname === "/view";
  const isSearchRoute = location.pathname === "/search";
  const isHomepageRoute = location.pathname === "/";

  React.useEffect(() => {
    const handleMenuClose = () => setMenuOpen(false);
    window.addEventListener("mobile-menu-closed", handleMenuClose);
    return () => window.removeEventListener("mobile-menu-closed", handleMenuClose);
  }, []);

  return (
    <nav aria-label="Primary navigation" className={`navbar ${isHomepage ? "ishomepage" : ""}`}>
      <div className={`navbar-left ${isHomepage ? "ishomepage" : ""}`}>
        <Link
          translate="no"
          to="/"
          aria-label={t('home')}
          className={`navbar-item ${isHomepage ? "ishomepage" : ""}`}
        >
          <img
            src={isHomepageRoute ? homepageIconSelected : homeicon}
            alt=""
            aria-hidden="true"
            style={{
              filter: "invert(1)",
            }}
          ></img>
          {t('home')} </Link>
        <Link
          to="/view"
          aria-label={t('products')}
          className={`navbar-item ${isHomepage ? "ishomepage" : ""}`}
        >
          <img
            src={isProductsRoute ? productsIconSelected : productsicon}
            alt=""
            aria-hidden="true"
          />
          {t('products')} </Link>
      </div>
      <div className={`navbar-center ${isHomepage ? "ishomepage" : ""}`}>
        <Link
          to="/"
          aria-label={t('home')}
          className={`navbar-item-center ${isHomepage ? "ishomepage" : ""}`}
        >
          <img src={dpp} alt="" aria-hidden="true" />
        </Link>
      </div>
      <div className={`navbar-right ${isHomepage ? "ishomepage" : ""}`}>
        <Link
          to="/search"
          aria-label={t('search')}
          className={`navbar-item ${isHomepage ? "ishomepage" : ""}`}
        >
          <img
            src={isSearchRoute ? searchiconSelected : searchicon}
            alt=""
            aria-hidden="true"
          ></img>
          {t('search')} </Link>
        <button
          type="button"
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          aria-haspopup="dialog"
          className={`navbar-item ${isHomepage ? "ishomepage" : ""}`}
          onClick={(event) => {
            setMenuOpen(true);
            MenuClick(event);
          }}
        >
          <img src={menu} alt="" aria-hidden="true"></img>
          {t('menu')} </button>
      </div>
    </nav>
  );
};

export default Navbar
